/**
 * naturalCompare.js — Feb 09 2026, Lane 2 follow-up.
 *
 * Tiny natural-order string comparator so periods like "Period 1",
 * "Period 2", "Period 10" sort in the intuitive order instead of
 * lexicographic ("Period 1", "Period 10", "Period 2"). Backed by
 * `Intl.Collator` with `numeric: true` — the built-in exists in every
 * modern browser and Node runtime, so we do not ship our own regex.
 *
 * Callers pass this to `Array.prototype.sort(comparator)` or use
 * `naturalCompare(a, b)` directly wherever `.localeCompare` would
 * mis-order numeric suffixes.
 */
const _collator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: "base",
});

export const naturalCompare = (a, b) => _collator.compare(a || "", b || "");

export default naturalCompare;
